import React, { useState, useRef } from 'react';
import { UploadIcon, XIcon, FileIcon, ImageIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FileUploadProps {
  label?: string;
  accept?: string;
  onChange: (fileUrl: string) => void;
  value?: string;
  helperText?: string;
}
export function FileUpload({
  label,
  accept = 'image/*,.pdf,.doc,.docx',
  onChange,
  value,
  helperText
}: FileUploadProps) {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // In a real app, you would upload to a server here.
      // For this demo, we'll create a local object URL.
      const url = URL.createObjectURL(file);
      onChange(url);
    }
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      onChange(url);
    }
  };
  const clearFile = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange('');
    if (inputRef.current) inputRef.current.value = '';
  };
  const isImage = value?.match(/\.(jpeg|jpg|gif|png)$/i) || value?.startsWith('blob:');
  return <div className="w-full" data-id="element-559">
      {label && <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-560">
          {label}
        </label>}

      <div onClick={() => !value && inputRef.current?.click()} onDragOver={e => {
      e.preventDefault();
      setIsDragging(true);
    }} onDragLeave={() => setIsDragging(false)} onDrop={handleDrop} className={`relative w-full rounded-xl border-2 border-dashed transition-all duration-200 overflow-hidden ${value ? 'border-gray-200 bg-gray-50' : isDragging ? 'border-[#007AFF] bg-[#F0F7FF]' : 'border-gray-300 bg-white hover:bg-gray-50 hover:border-gray-400 cursor-pointer'}`} data-id="element-561">
        <input type="file" ref={inputRef} onChange={handleFileChange} accept={accept} className="hidden" data-id="element-562" />

        <AnimatePresence mode="wait" data-id="element-563">
          {value ? <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="p-4 flex items-center justify-between" data-id="element-564">
              <div className="flex items-center space-x-4 overflow-hidden" data-id="element-565">
                <div className="w-12 h-12 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-566">
                  {isImage ? <img src={value} alt="Preview" className="w-full h-full object-cover" data-id="element-567" /> : <FileIcon className="w-6 h-6 text-[#007AFF]" data-id="element-568" />}
                </div>
                <div className="truncate" data-id="element-569">
                  <p className="text-sm font-medium text-gray-900 truncate" data-id="element-570">
                    Bestand geüpload
                  </p>
                  <p className="text-xs text-gray-500 truncate" data-id="element-571">
                    Klik op het kruisje om te verwijderen
                  </p>
                </div>
              </div>
              <button onClick={clearFile} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-572">
                <XIcon className="w-5 h-5" data-id="element-573" />
              </button>
            </motion.div> : <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="p-8 text-center" data-id="element-574">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#F0F7FF] flex items-center justify-center" data-id="element-575">
                <UploadIcon className="w-6 h-6 text-[#007AFF]" data-id="element-576" />
              </div>
              <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-577">
                Klik of sleep een bestand hierheen
              </p>
              <p className="text-xs text-gray-500" data-id="element-578">
                {helperText || 'Ondersteunt afbeeldingen en documenten'}
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}